// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.MuiBox-root.popup-content-text {
  @media screen and (min-width: 768px) {
    width: 80%;
  }
}
.MuiTypography-root.popup-content-title {
  font-family: var(--font-family-primary);
  font-weight: 700;
  font-size: 33px;
  text-align: left;
  padding-left: 20px;
  margin-bottom: 0.5rem;
  @media screen and (min-width: 768px) {
    padding-left: 51px;
  }
}
.MuiTypography-root.popup-title {
  transform: rotate(-48deg);
  position: absolute;
  padding: 0px 21px;
  top: 25px;
  left: -24px;
  font-family: var(--font-family-primary);
  font-weight: 600;
  font-size: 12px;
  color: #ebebf5;
}
span {
  color: #fff;
}
.MuiTypography-root.popup-content-description {
  position: absolute;
  font-family: var(--font-family-primary);
  font-weight: 400;
  font-size: 15px;
  color: #ebebf5;
  text-align: left;
  padding-left: 20px;
  @media screen and (min-width: 768px) {
    width: 53%;
    padding-left: 51px;
  }
}
.MuiBox-root.popup-content-button {
  top: 400px;
  position: absolute;
  padding-left: 20px;
  z-index: 100;
  @media screen and (min-width: 768px) {
    top: 344px;
    padding-left: 51px;
  }
}
/* .MuiButtonBase-root.styledButton {
  padding: 0px 30px;
} */

.close-btn {
  position: absolute !important;
  right: 10px;
  top: 10px;
  color: white !important;
  padding: 0px;
}

.MuiBox-root.heartImage {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: absolute;
    left: 62%;
    top: 150px;
  }
}
.MuiBox-root.ValentineCoupleImage {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: relative;
    left: 30px;
  }
}
.MuiBox-root.heartsecond {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: absolute;
  }
}
.MuiBox-root.heartoutline {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: absolute;
    left: 13%;
    bottom: 9%;
    z-index: 11;
  }
}
.MuiBox-root.menLogo {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: absolute;
    left: 23%;
    bottom: 11%;
    z-index: 10;
  }
}
.MuiBox-root.womenLogo {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: absolute;
    left: 40%;
    bottom: 30%;
  }
}
.MuiBox-root.plus {
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
    position: absolute;
    left: 41%;
    bottom: 36%;
    z-index: 10;
  }
}
.popup-modal .MuiBackdrop-root.MuiModal-backdrop {
  background: linear-gradient(
    135deg,
    rgba(46, 51, 90, 0.8),
    rgba(28, 27, 51, 0.8)
  );
}
.css-1gxj0f5-MuiGrid-root>.MuiGrid-item {
  padding-left: 0px !important;
}


.MuiTypography-root.header-text {
  font-size: 20px;
  font-family: var(--font-family-primary);
  font-weight: 500;
  text-align: left;
  color: #EBEBF5;
  margin-bottom: 10px;
}

.MuiTypography-root.subheading-text {
  font-size: 16px;
  font-family: var(--font-family-primary);
  font-weight: 400;
  text-align: left;
}
.main-grid {
  display: grid;
  gap: 20px;
  align-items: center;
  justify-content: center;
  grid-template-columns: 1fr;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .main-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1023px) and (max-width: 1440px) {
  .main-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1441px) {
  .main-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

.modelCard {
  margin-bottom: 1rem;
}



.arrow-icon {
  display: flex;
  justify-content: flex-end;
}
.image-grid-idea {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-images {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}
.stacked-images {
  object-fit: contain;
 width: 100%;
  border-radius: 10px;
}

.model-type {
  border-radius: 8px;
  border: 1px white solid;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.model-type-selected {
  background: #3F3589;
  border-radius: 8px;
  border: 1px white solid;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.countContainer{
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  justify-content: space-between;
}

.MuiSvgIcon-root.close-btn{
  color: #fff !important;
}
.MuiPaper-root.MuiPaper-elevation{
  background-color: #2d2d55;
}
.MuiButtonBase-root.previewButton {
  background-color: #69319D;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  font-family: var(--font-family-primary);
  border-radius: 4px;
  display: flex;
  justify-content: space-evenly;
  z-index: 2;
  transition: background-color 0.3s ease;
  border-radius: 20px;
  padding: 2px 20px;
}

.MuiButtonBase-root.previewButton:hover {
  background-color: #69319D;
}
.MuiSvgIcon-root.iconColor{
  color: #fff;
}

.MuiBox-root.buttonContainer-btn{
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 45%;
  z-index: 2;
}

.MuiTypography-root.previewText{
  font-size: 12px;
  font-family:var(--font-family-primary);
  font-weight: 400;
  color: #fff;
  text-transform: none;
}
.MuiDialogContent-root.dialogContentcontainer{
 display: flex;
 justify-content: center;
 gap: 10px;
 flex-direction: column;
}
@media screen and (min-width: 768px) {
  .MuiDialogContent-root.dialogContentcontainer{
    flex-direction: row-reverse;
  }
  
}
.previewImage{
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 768px) {
  .previewImage{
    width: 50%;
  }
  
}
.textBox{
  padding: 10px;
  height: 100%;
}

/* New Modal Page */
.idea-board-title{
  padding: 20px;
}
.MuiGrid-root.idea-board-model{
  display: flex;
  align-items: center;
  gap: 20px;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: center;
}
@media screen and (min-width: 600px) and (max-width: 1023px) {
  .MuiGrid-root.idea-board-model{
    flex-direction: row;
    gap: 0px;
    justify-content: flex-start;
  }
}
@media screen and (min-width: 1024px) {
  .MuiGrid-root.idea-board-model{
    flex-direction: row;
    justify-content: flex-start;
    gap: 0px;
    align-items: center;
}
@media screen and (min-width: 1600px) {
  .MuiGrid-root.idea-board-model{
    flex-direction: row;
  }
}
  
}
.MuiPaper-root.idea-card{
  display: flex;
  gap: 1px;
  width: 100%;
  align-items: center;
  position: relative;
  background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);
  justify-content: center;
  cursor: pointer;
}
.MuiCardContent-root.card-content{
  background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);
}
.MuiGrid-root.gradient-background.height-content{
  height: 70vh;
  overflow-y: auto;
}
@media screen and (min-width: 768px) {
  .MuiGrid-root.gradient-background.height-content{
    height: 90vh;
    overflow-y: auto;
  }
  
}
.generatedImagesContainer{
  overflow-y: auto;
  height: calc(100vh - 50px);
}
.MuiGrid-root.generatedImagesContainer{
  overflow-y: auto;
  height: calc(100vh - 50px);
}
.MuiTypography-root.ribbon {
  display: inline-block;
  background: #E21515;
  color: white;
  padding: 10px 43px;
  font-size: 16px;
  font-weight: 600;
  font-family: var(--font-family-primary);
  position: relative;
  color: #EBEBF5;
}

.MuiTypography-root.ribbon::after {
  content: "";
  position: absolute;
  top: 0;
  right: -14px;
  width: 0;
  height: 0;
  border-top: 20px solid #E21515;
  border-bottom: 20px solid #E21515;
  border-left: 15px solid transparent;
  transform: rotate(180deg);
}
.MuiTypography-root.ribbon-cartoon {
  display: inline-block;
  background: #9d4fe7;
  color: white;
  padding: 10px 43px;
  font-size: 16px;
  font-weight: 600;
  font-family: var(--font-family-primary);
  position: relative;
  color: #EBEBF5;
}

.MuiTypography-root.ribbon-cartoon::after {
  content: "";
  position: absolute;
  top: 0;
  right: -14px;
  width: 0;
  height: 0;
  border-top: 20px solid #9d4fe7;
  border-bottom: 19.5px solid #9d4fe7;
  border-left: 15px solid transparent;
  transform: rotate(180deg);
}

.MuiBox-root.ribbon-container{
  margin-top: 20px;
}
.MuiGrid-root.gridUploadImage{
  margin-top: -6px;
}
.MuiGrid-root.MuiGrid-item.gridPlusIcon{
  padding-top: 14%;
}

.MuiBox-root.cartoon-uploader {
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 122px);
  overflow-y: auto;
}

.MuiBox-root.upload-Container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.uploadImages{
  position: absolute;
  text-align: center;
  top: 0;
  bottom: 0;
}
.upload-content-container{
  position: absolute;
  text-align: center;
  width: 100%;
}
.delete-icon-container{
  position: relative;
  width: 100%;
  display: flex;
  justify-content: end;
}
.MuiSvgIcon-root.delete-icon{
  color: red;
  cursor: pointer;
  position: absolute;
  bottom: 14px;
  right: 12%;
}
.MuiBox-root.input-container {
  border: 2px dashed #8B8585;
  border-radius: 12px;
  height: 211px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}
.MuiBox-root.upload-button-container{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.MuiBox-root.upload-button-container:focus-visible{
outline: none;
border: none;
}
.MuiBox-root.upload-button-container .MuiButtonBase-root{
  width: 100%;
}
.previewImages{
  width: 100%;
    height: 253px;
    object-fit: contain;
}
.upload-existing-images{
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  overflow-y: auto;
  justify-content: center;
}
.upload-existing-images::-webkit-scrollbar {
  width: 4px;
}
.upload-existing-images::-webkit-scrollbar-thumb {
  background-color: #ECEDF8;
  border-radius: 10px;
}
.cartoonImages{
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  overflow-y: auto;
  justify-content: center;
}
.cartoonImages::-webkit-scrollbar {
  width: 4px;
}
.cartoonImages::-webkit-scrollbar-thumb {
  background-color: #ECEDF8;
  border-radius: 10px;
}
.upload-existing-image{
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  overflow-y: auto;
  height: calc(100% - 300px);
  justify-content: center;
}
.upload-existing-image::-webkit-scrollbar {
  width: 4px;
}
.upload-existing-image::-webkit-scrollbar-thumb {
  background-color: #ECEDF8;
  border-radius: 10px;
}
.MuiBox-root.generated-Images{
  overflow-y: auto;
  height: calc(100vh - 30px);
}
.generated-Images::-webkit-scrollbar {
  width: 4px;
}
.generated-Images::-webkit-scrollbar-thumb {
  background-color: #ECEDF8;
  border-radius: 10px;
}
.hoverbtn-cartoon {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px; 
}
.MuiPaper-root{
  --Paper-shadow: none !important;
}
.MuiPaper-root .MuiCardMedia-root.generate-Image-card{
height: 212px;
object-fit: contain;
}
.MuiPaper-root .MuiCardMedia-root.generate-blur-card{
opacity: 0.3;
cursor: not-allowed;
}
.MuiPaper-root.existing-card{
  border-radius: 8px;
}
.MuiPaper-root.generate-card{
  position: relative;
 background-color: #2B284A;
 border-radius: 8px;
}
.MuiTypography-root.subTitle{
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 10px;
  color: #fff;
}
.MuiBox-root.upload-image-container{
  cursor: pointer;
  height: calc(100vh - 480px);
  overflow-y: auto;
}
.MuiBox-root.upload-image-container2{
  cursor: pointer;
  height: calc(100vh - 640px);
  overflow-y: auto;
}
.MuiBox-root.leftUploader{
  background: #292B49;
    padding: 20px;
    border-radius: 8px;
}
.MuiTypography-root.cartoonTitle{
  font-size: 20px;
  font-weight: 600;
  font-family: var(--font-family-primary);
      padding: 24px 0px 0px 24px;
}
.previewImages{
  height: 200px;
  object-fit: contain;
  border-radius: 8px;
  position: relative;
  top: 3px;
}
.MuiTypography-root.ideaBoardTitle{
  font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 20px;
    color: #EBEBF5;
}
.buttonIdeacontainer{
  display: flex;
flex-direction: column;
gap: 10px;
  margin: 11px 0;
}

@media screen and (min-width: 768px) {
  .MuiBox-root.cartoon-uploader {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-direction: row;
    height: 88vh;
    overflow: hidden;
  }
  .buttonIdeacontainer{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0px;
  margin: 11px 0;
}
.generatedImagesContainer{
  overflow-y: auto;
  height: calc(100vh - 580px);
}
.MuiGrid-root.generatedImagesContainer{
  overflow-y: auto;
  height: calc(100vh - 580px);
}
  .upload-existing-images{
    justify-content: flex-start;
    gap: 5px;
  }
  .MuiBox-root.upload-button-container .MuiButtonBase-root{
  width: 70%;
}
.MuiBox-root.leftUploader{
   height: calc(100vh - 190px);
}
.MuiBox-root.leftUploader.ProductScape{
  height: 100%;
}
}
@media screen and (min-width: 1023px) {
  .upload-existing-images{
    justify-content: flex-start;
    gap: 10px;
    /* height: 180px; */
  }
  .previewImages{
  height: 200px;
  object-fit: contain;
  border-radius: 8px;
  position: relative;
  top: 3px;
}
.MuiBox-root.upload-button-container .MuiButtonBase-root{
  width: 50%;
}

}



.my-masonry-grids{
  display: flex;
  width: 100%;
  gap: 7px;
  cursor: pointer;
}

@media screen and (max-width: 460px) {
.MuiBox-root.generated-Images{
height: 100%;
}
.MuiBox-root.upload-image-container, .MuiBox-root.upload-image-container2 {
  display: none;
}
  
}

`, "",{"version":3,"sources":["webpack://./src/components/IdeaBoard/IdeaBoard.css"],"names":[],"mappings":";AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB;IACE,kBAAkB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;AACA;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE;;;;GAIC;AACH;AACA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;CACpB,WAAW;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,UAAU;EACV,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,SAAS;CACT,sBAAsB;AACvB;AACA;EACE;IACE,2BAA2B;EAC7B;;AAEF;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,UAAU;EACZ;;AAEF;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;AACA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;AACvB;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;AACA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6FAA6F;EAC7F,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,6FAA6F;AAC/F;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;AAEF;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;AACA,aAAa;AACb,YAAY;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;IACT,aAAa;IACb,mBAAmB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;EACN,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;AACA,aAAa;AACb,mBAAmB;AACnB;AACA;AACA,YAAY;AACZ,mBAAmB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,mBAAmB;IACjB,aAAa;IACb,kBAAkB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;MACnC,0BAA0B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,uCAAuC;IACrC,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;EACE,aAAa;AACf,sBAAsB;AACtB,SAAS;EACP,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;EAClB;EACA;EACA,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;EACE;IACE,2BAA2B;IAC3B,QAAQ;EACV;EACA;EACA,UAAU;AACZ;AACA;GACG,2BAA2B;AAC9B;AACA;EACE,YAAY;AACd;AACA;AACA;EACE;IACE,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;EACrB;EACA;EACA,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,UAAU;AACZ;;AAEA;;;;AAIA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;AACA;AACA,YAAY;AACZ;AACA;EACE,aAAa;AACf;;AAEA","sourcesContent":["\n.MuiBox-root.popup-content-text {\n  @media screen and (min-width: 768px) {\n    width: 80%;\n  }\n}\n.MuiTypography-root.popup-content-title {\n  font-family: var(--font-family-primary);\n  font-weight: 700;\n  font-size: 33px;\n  text-align: left;\n  padding-left: 20px;\n  margin-bottom: 0.5rem;\n  @media screen and (min-width: 768px) {\n    padding-left: 51px;\n  }\n}\n.MuiTypography-root.popup-title {\n  transform: rotate(-48deg);\n  position: absolute;\n  padding: 0px 21px;\n  top: 25px;\n  left: -24px;\n  font-family: var(--font-family-primary);\n  font-weight: 600;\n  font-size: 12px;\n  color: #ebebf5;\n}\nspan {\n  color: #fff;\n}\n.MuiTypography-root.popup-content-description {\n  position: absolute;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  font-size: 15px;\n  color: #ebebf5;\n  text-align: left;\n  padding-left: 20px;\n  @media screen and (min-width: 768px) {\n    width: 53%;\n    padding-left: 51px;\n  }\n}\n.MuiBox-root.popup-content-button {\n  top: 400px;\n  position: absolute;\n  padding-left: 20px;\n  z-index: 100;\n  @media screen and (min-width: 768px) {\n    top: 344px;\n    padding-left: 51px;\n  }\n}\n/* .MuiButtonBase-root.styledButton {\n  padding: 0px 30px;\n} */\n\n.close-btn {\n  position: absolute !important;\n  right: 10px;\n  top: 10px;\n  color: white !important;\n  padding: 0px;\n}\n\n.MuiBox-root.heartImage {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: absolute;\n    left: 62%;\n    top: 150px;\n  }\n}\n.MuiBox-root.ValentineCoupleImage {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: relative;\n    left: 30px;\n  }\n}\n.MuiBox-root.heartsecond {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: absolute;\n  }\n}\n.MuiBox-root.heartoutline {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: absolute;\n    left: 13%;\n    bottom: 9%;\n    z-index: 11;\n  }\n}\n.MuiBox-root.menLogo {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: absolute;\n    left: 23%;\n    bottom: 11%;\n    z-index: 10;\n  }\n}\n.MuiBox-root.womenLogo {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: absolute;\n    left: 40%;\n    bottom: 30%;\n  }\n}\n.MuiBox-root.plus {\n  display: none;\n  @media screen and (min-width: 768px) {\n    display: block;\n    position: absolute;\n    left: 41%;\n    bottom: 36%;\n    z-index: 10;\n  }\n}\n.popup-modal .MuiBackdrop-root.MuiModal-backdrop {\n  background: linear-gradient(\n    135deg,\n    rgba(46, 51, 90, 0.8),\n    rgba(28, 27, 51, 0.8)\n  );\n}\n.css-1gxj0f5-MuiGrid-root>.MuiGrid-item {\n  padding-left: 0px !important;\n}\n\n\n.MuiTypography-root.header-text {\n  font-size: 20px;\n  font-family: var(--font-family-primary);\n  font-weight: 500;\n  text-align: left;\n  color: #EBEBF5;\n  margin-bottom: 10px;\n}\n\n.MuiTypography-root.subheading-text {\n  font-size: 16px;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n  text-align: left;\n}\n.main-grid {\n  display: grid;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n  .main-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (min-width: 1023px) and (max-width: 1440px) {\n  .main-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 1441px) {\n  .main-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n.modelCard {\n  margin-bottom: 1rem;\n}\n\n\n\n.arrow-icon {\n  display: flex;\n  justify-content: flex-end;\n}\n.image-grid-idea {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.left-images {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n}\n.stacked-images {\n  object-fit: contain;\n width: 100%;\n  border-radius: 10px;\n}\n\n.model-type {\n  border-radius: 8px;\n  border: 1px white solid;\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n}\n.model-type-selected {\n  background: #3F3589;\n  border-radius: 8px;\n  border: 1px white solid;\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n}\n\n.countContainer{\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  justify-content: space-between;\n}\n\n.MuiSvgIcon-root.close-btn{\n  color: #fff !important;\n}\n.MuiPaper-root.MuiPaper-elevation{\n  background-color: #2d2d55;\n}\n.MuiButtonBase-root.previewButton {\n  background-color: #69319D;\n  color: #fff;\n  font-weight: bold;\n  font-size: 12px;\n  font-family: var(--font-family-primary);\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-evenly;\n  z-index: 2;\n  transition: background-color 0.3s ease;\n  border-radius: 20px;\n  padding: 2px 20px;\n}\n\n.MuiButtonBase-root.previewButton:hover {\n  background-color: #69319D;\n}\n.MuiSvgIcon-root.iconColor{\n  color: #fff;\n}\n\n.MuiBox-root.buttonContainer-btn{\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 45%;\n  z-index: 2;\n}\n\n.MuiTypography-root.previewText{\n  font-size: 12px;\n  font-family:var(--font-family-primary);\n  font-weight: 400;\n  color: #fff;\n  text-transform: none;\n}\n.MuiDialogContent-root.dialogContentcontainer{\n display: flex;\n justify-content: center;\n gap: 10px;\n flex-direction: column;\n}\n@media screen and (min-width: 768px) {\n  .MuiDialogContent-root.dialogContentcontainer{\n    flex-direction: row-reverse;\n  }\n  \n}\n.previewImage{\n  width: 100%;\n  height: 100%;\n}\n@media screen and (min-width: 768px) {\n  .previewImage{\n    width: 50%;\n  }\n  \n}\n.textBox{\n  padding: 10px;\n  height: 100%;\n}\n\n/* New Modal Page */\n.idea-board-title{\n  padding: 20px;\n}\n.MuiGrid-root.idea-board-model{\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-direction: column;\n  flex-wrap: wrap;\n  padding: 20px;\n  justify-content: center;\n}\n@media screen and (min-width: 600px) and (max-width: 1023px) {\n  .MuiGrid-root.idea-board-model{\n    flex-direction: row;\n    gap: 0px;\n    justify-content: flex-start;\n  }\n}\n@media screen and (min-width: 1024px) {\n  .MuiGrid-root.idea-board-model{\n    flex-direction: row;\n    justify-content: flex-start;\n    gap: 0px;\n    align-items: center;\n}\n@media screen and (min-width: 1600px) {\n  .MuiGrid-root.idea-board-model{\n    flex-direction: row;\n  }\n}\n  \n}\n.MuiPaper-root.idea-card{\n  display: flex;\n  gap: 1px;\n  width: 100%;\n  align-items: center;\n  position: relative;\n  background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);\n  justify-content: center;\n  cursor: pointer;\n}\n.MuiCardContent-root.card-content{\n  background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);\n}\n.MuiGrid-root.gradient-background.height-content{\n  height: 70vh;\n  overflow-y: auto;\n}\n@media screen and (min-width: 768px) {\n  .MuiGrid-root.gradient-background.height-content{\n    height: 90vh;\n    overflow-y: auto;\n  }\n  \n}\n.generatedImagesContainer{\n  overflow-y: auto;\n  height: calc(100vh - 50px);\n}\n.MuiGrid-root.generatedImagesContainer{\n  overflow-y: auto;\n  height: calc(100vh - 50px);\n}\n.MuiTypography-root.ribbon {\n  display: inline-block;\n  background: #E21515;\n  color: white;\n  padding: 10px 43px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: var(--font-family-primary);\n  position: relative;\n  color: #EBEBF5;\n}\n\n.MuiTypography-root.ribbon::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: -14px;\n  width: 0;\n  height: 0;\n  border-top: 20px solid #E21515;\n  border-bottom: 20px solid #E21515;\n  border-left: 15px solid transparent;\n  transform: rotate(180deg);\n}\n.MuiTypography-root.ribbon-cartoon {\n  display: inline-block;\n  background: #9d4fe7;\n  color: white;\n  padding: 10px 43px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: var(--font-family-primary);\n  position: relative;\n  color: #EBEBF5;\n}\n\n.MuiTypography-root.ribbon-cartoon::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: -14px;\n  width: 0;\n  height: 0;\n  border-top: 20px solid #9d4fe7;\n  border-bottom: 19.5px solid #9d4fe7;\n  border-left: 15px solid transparent;\n  transform: rotate(180deg);\n}\n\n.MuiBox-root.ribbon-container{\n  margin-top: 20px;\n}\n.MuiGrid-root.gridUploadImage{\n  margin-top: -6px;\n}\n.MuiGrid-root.MuiGrid-item.gridPlusIcon{\n  padding-top: 14%;\n}\n\n.MuiBox-root.cartoon-uploader {\n  display: flex;\n  flex-direction: column;\n  height: calc(100dvh - 122px);\n  overflow-y: auto;\n}\n\n.MuiBox-root.upload-Container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.uploadImages{\n  position: absolute;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n}\n.upload-content-container{\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n.delete-icon-container{\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: end;\n}\n.MuiSvgIcon-root.delete-icon{\n  color: red;\n  cursor: pointer;\n  position: absolute;\n  bottom: 14px;\n  right: 12%;\n}\n.MuiBox-root.input-container {\n  border: 2px dashed #8B8585;\n  border-radius: 12px;\n  height: 211px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n}\n.MuiBox-root.upload-button-container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n}\n.MuiBox-root.upload-button-container:focus-visible{\noutline: none;\nborder: none;\n}\n.MuiBox-root.upload-button-container .MuiButtonBase-root{\n  width: 100%;\n}\n.previewImages{\n  width: 100%;\n    height: 253px;\n    object-fit: contain;\n}\n.upload-existing-images{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  overflow-y: auto;\n  justify-content: center;\n}\n.upload-existing-images::-webkit-scrollbar {\n  width: 4px;\n}\n.upload-existing-images::-webkit-scrollbar-thumb {\n  background-color: #ECEDF8;\n  border-radius: 10px;\n}\n.cartoonImages{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  overflow-y: auto;\n  justify-content: center;\n}\n.cartoonImages::-webkit-scrollbar {\n  width: 4px;\n}\n.cartoonImages::-webkit-scrollbar-thumb {\n  background-color: #ECEDF8;\n  border-radius: 10px;\n}\n.upload-existing-image{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  overflow-y: auto;\n  height: calc(100% - 300px);\n  justify-content: center;\n}\n.upload-existing-image::-webkit-scrollbar {\n  width: 4px;\n}\n.upload-existing-image::-webkit-scrollbar-thumb {\n  background-color: #ECEDF8;\n  border-radius: 10px;\n}\n.MuiBox-root.generated-Images{\n  overflow-y: auto;\n  height: calc(100vh - 30px);\n}\n.generated-Images::-webkit-scrollbar {\n  width: 4px;\n}\n.generated-Images::-webkit-scrollbar-thumb {\n  background-color: #ECEDF8;\n  border-radius: 10px;\n}\n.hoverbtn-cartoon {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  background-color: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px; \n}\n.MuiPaper-root{\n  --Paper-shadow: none !important;\n}\n.MuiPaper-root .MuiCardMedia-root.generate-Image-card{\nheight: 212px;\nobject-fit: contain;\n}\n.MuiPaper-root .MuiCardMedia-root.generate-blur-card{\nopacity: 0.3;\ncursor: not-allowed;\n}\n.MuiPaper-root.existing-card{\n  border-radius: 8px;\n}\n.MuiPaper-root.generate-card{\n  position: relative;\n background-color: #2B284A;\n border-radius: 8px;\n}\n.MuiTypography-root.subTitle{\n  font-family: var(--font-family-primary);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.5;\n  margin-bottom: 10px;\n  color: #fff;\n}\n.MuiBox-root.upload-image-container{\n  cursor: pointer;\n  height: calc(100vh - 480px);\n  overflow-y: auto;\n}\n.MuiBox-root.upload-image-container2{\n  cursor: pointer;\n  height: calc(100vh - 640px);\n  overflow-y: auto;\n}\n.MuiBox-root.leftUploader{\n  background: #292B49;\n    padding: 20px;\n    border-radius: 8px;\n}\n.MuiTypography-root.cartoonTitle{\n  font-size: 20px;\n  font-weight: 600;\n  font-family: var(--font-family-primary);\n      padding: 24px 0px 0px 24px;\n}\n.previewImages{\n  height: 200px;\n  object-fit: contain;\n  border-radius: 8px;\n  position: relative;\n  top: 3px;\n}\n.MuiTypography-root.ideaBoardTitle{\n  font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 20px;\n    color: #EBEBF5;\n}\n.buttonIdeacontainer{\n  display: flex;\nflex-direction: column;\ngap: 10px;\n  margin: 11px 0;\n}\n\n@media screen and (min-width: 768px) {\n  .MuiBox-root.cartoon-uploader {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    flex-direction: row;\n    height: 88vh;\n    overflow: hidden;\n  }\n  .buttonIdeacontainer{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0px;\n  margin: 11px 0;\n}\n.generatedImagesContainer{\n  overflow-y: auto;\n  height: calc(100vh - 580px);\n}\n.MuiGrid-root.generatedImagesContainer{\n  overflow-y: auto;\n  height: calc(100vh - 580px);\n}\n  .upload-existing-images{\n    justify-content: flex-start;\n    gap: 5px;\n  }\n  .MuiBox-root.upload-button-container .MuiButtonBase-root{\n  width: 70%;\n}\n.MuiBox-root.leftUploader{\n   height: calc(100vh - 190px);\n}\n.MuiBox-root.leftUploader.ProductScape{\n  height: 100%;\n}\n}\n@media screen and (min-width: 1023px) {\n  .upload-existing-images{\n    justify-content: flex-start;\n    gap: 10px;\n    /* height: 180px; */\n  }\n  .previewImages{\n  height: 200px;\n  object-fit: contain;\n  border-radius: 8px;\n  position: relative;\n  top: 3px;\n}\n.MuiBox-root.upload-button-container .MuiButtonBase-root{\n  width: 50%;\n}\n\n}\n\n\n\n.my-masonry-grids{\n  display: flex;\n  width: 100%;\n  gap: 7px;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 460px) {\n.MuiBox-root.generated-Images{\nheight: 100%;\n}\n.MuiBox-root.upload-image-container, .MuiBox-root.upload-image-container2 {\n  display: none;\n}\n  \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
